var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',{attrs:{"visibility-height":200}},[_c('i',{staticClass:"iconfont el-icon-arrow-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }